export default {
    styleOverrides: {
        root: {
            width: "100%",
            overflowX: 'scroll',
        }
    }
}